export default __webpack_public_path__ + "85698574e6fec19ac5183e048df2009c.svg";